export default __webpack_public_path__ + "static/mission-ops-e1974d8b7877b00d231900204d25d281.png";